module.exports = __webpack_public_path__ + "img/01.10e4afcf.png";